const bankAccounts = [
    {
        id: 1,
        name: 'Jackson - Settlement',
        accountDetails: '6347373893 - GTBank',
        accountStatus: 'active'
    },
    {
        id: 2,
        name: 'Cynthia - Settlement',
        accountDetails: '7383973628 - Access',
        accountStatus: 'active'
    },
    {
        id: 3,
        name: 'Yemi - Settlement',
        accountDetails: '9038772627 - FCMB',
        accountStatus: 'active'
    },
    {
        id: 4,
        name: 'Nikelideon - Settlement',
        accountDetails: '7689765439 - UBA',
        accountStatus: 'active'
    }
];

export function getAccounts() {
    return bankAccounts;
}
